import { loadStripe, type Stripe } from '@stripe/stripe-js';

// loadStripe injects a <script> per key — cache so a re-render doesn't add more.
const clients = new Map<string, Promise<Stripe | null>>();

export function stripeFor(publishableKey: string): Promise<Stripe | null> {
  let client = clients.get(publishableKey);
  if (!client) {
    client = loadStripe(publishableKey);
    clients.set(publishableKey, client);
  }
  return client;
}
